<template>
  <section class="pricing-section">
    <h2 class="text-center mb-4">
      Pricing
    </h2>
    <div class="pricing-grid">
      <div
        v-for="plan in plans"
        :key="plan.name"
        class="pricing-card"
        :class="{ featured: plan.featured }"
      >
        <div class="pricing-shape-img">
          <img
            decoding="async"
            width="75"
            height="74"
            src="../assets/images/pricing-card-shape.svg"
            alt="Pricing card shape"
          >
        </div>
        <h3 class="plan-title">
          {{ plan.name }}
        </h3>
        <p class="plan-description">
          {{ plan.description }}
        </p>
        <div class="plan-price">
          <span class="currency">£</span>
          <span :class="{ 'strikethrough': plan.discount > 0 }">{{ formatPrice(plan.price) }}</span>
          <!-- period boştu; kaldırıldı -->
          <br>
          <span
            v-if="plan.discount > 0"
            class="discount"
          >%{{ plan.discount }} off (Save £{{ formatPrice(plan.price - discountedPrice(plan)) }}) £{{ formatPrice(discountedPrice(plan)) }} </span>
        </div>
        <ul class="plan-features">
          <li
            v-for="(feature, i) in plan.features"
            :key="i"
          >
            <i class="fa-solid fa-arrow-right" /> {{ feature }}
          </li>
        </ul>
        <button class="plan-button">
          Choose {{ plan.name }}
        </button>
      </div>
    </div>
    <!-- 
        <h2 class="text-center mb-4">Pricing Plans</h2>
        <div class="pricing-grid">
          <div v-for="(plan, index) in plans" :key="index" class="pricing-card" :class="{ featured: plan.featured }">
            <div class="pricing-shape-img"> 
              <img  decoding="async" width="75" height="74" src="../assets/images/pricing-card-shape.svg"> </div>
            <h3 class="plan-title">{{ plan.name }}</h3>
            <p class="plan-description">{{ plan.description }}</p>
            <div class="plan-price">
              <span class="currency">₺</span>{{ plan.price }}<span class="period">/month</span>
              
            </div>
            <ul class="plan-features">
              <li v-for="(feature, i) in plan.features" :key="i">
                <i class="fa-solid fa-arrow-right"></i> {{ feature }}
              </li>
            </ul>
            <button class="plan-button">Choose {{ plan.name }}</button>
            
          </div>
        </div>
         -->
  </section>
</template>
  
  <script setup>
  /* eslint-disable */
  const plans = [
    {
      name: '1 AD',
      price: 0.99,
      discount: 0,
      description: 'Perfect for Personal use.',
      features: ['1 Active Listing', 'Community Access', 'Basic Support'],
      featured: false,
    },
    {
      name: '3 AD',
      price: 2.97,
      discount: 10,
      description: 'Perfect for hobby breeders.',
      features: ['3 Active Listing', 'Community Access', 'Basic Support'],
      featured: true,
    },
    {
      name: '5 AD',
      price: 4.95,
      discount: 15,
      description: 'Perfect for growing pet businesses.',
      features: ['5 Active Listing', 'Community Access', 'Basic Support'],
      featured: false,
    }
  ];

  const formatPrice = (n) => n.toFixed(2);
const discountedPrice = (plan) => plan.price * (1 - plan.discount / 100);
  </script>
  
  <style scoped>
  .pricing-section {
    width: 100%;
  }
  .pricing-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    margin: 20px;
  }
  .pricing-card {
    flex: 1 1 30%;
    background: #fff;
    border-radius: 10px;
    padding: 25px;
    text-align: center;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative; /* absolute child için referans */
  }
  .pricing-shape-img {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 0;
    opacity: 0.5;
  }
  .pricing-card > *:not(.pricing-shape-img) {
    position: relative;
    z-index: 1;
  }
  .pricing-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
  .featured {
    border: 2px solid #e91e63;
    box-shadow: 0 0 0 4px rgba(233, 30, 99, 0.1);
  }
  .plan-title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .plan-description {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 15px;
  }
  .plan-price {
    font-size: 2rem;
    color: #e91e63;
    margin: 15px 0;
  }
  .plan-price .period {
    font-size: 1rem;
    color: #888;
  }
  .plan-features {
    list-style: none;
    padding: 0;
    margin: 15px 0;
    text-align: left;
  }
  .plan-features li {
    font-size: 0.95rem;
    margin-bottom: 8px;
  }
  .plan-button {
    padding: 10px 20px;
    background-color: #e91e63;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  .plan-button:hover {
    background-color: #c2185b;
  }
  .strikethrough {
  text-decoration: line-through;
  opacity: 0.75;
}
.discount {
  display: inline-block;
  font-size: 1.4rem;
  color: #2e7d32;
  margin-top: 4px;
}
  @media (max-width: 768px) {
    .pricing-card {
      flex: 1 1 100%;
    }
  }
  </style>
